import { css } from 'styled-components';

export default css`
  padding: 10px;
`;
